import React, { useEffect, useState } from 'react';
import { Menu, Globe } from 'lucide-react';
import { motion } from 'framer-motion';
export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-primary-dark/95 backdrop-blur-sm py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-114">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-115">
        <div className="flex items-center" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/m22cd52VGFAbga9BNLUyHJ/accutemp-logo-white.svg" alt="Accutemp Air Conditioning" className="h-8 md:h-10 w-auto" data-id="element-117" />
        </div>

        <div className="hidden lg:flex items-center gap-8 text-white/90 text-sm font-medium" data-id="element-118">
          <a href="#" className="hover:text-white transition-colors" data-id="element-119">
            Services
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-120">
            Why Us
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-121">
            Case Studies
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-122">
            Knowledge Hub
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-123">
            Contact
          </a>
        </div>

        <div className="flex items-center gap-6 text-white" data-id="element-124">
          <button className="hidden sm:flex items-center gap-2 text-sm font-medium hover:text-white/80 transition-colors" data-id="element-125">
            <Globe size={18} data-id="element-126" />
            <span data-id="element-127">EN</span>
          </button>
          <button className="hover:text-white/80 transition-colors" data-id="element-128">
            <Menu size={28} data-id="element-129" />
          </button>
        </div>
      </div>
    </motion.nav>;
}